const products = {
  name: 'Nom du produit',
  name_en: 'Nom du produit',
  name_fr: 'Nom du produit',
};

export default products;
